module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.newTaskBoardOnClick
    }
  }, [_vm._v("Создать новую доску")]), _vm._v(" "), (_vm.commonData.isLoaded == true) ? _c('el-tabs', {
    attrs: {
      "tab-position": "left",
      "style222222222222": "height:calc(100% - 50px);"
    }
  }, _vm._l((_vm.commonData.taskBoards), function(item, key) {
    return _c('el-tab-pane', {
      key: key
    }, [_c('span', {
      slot: "label"
    }, [_c('div', {
      staticClass: "board-title"
    }, [_c('span', [_vm._v(_vm._s(item.val.name))]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.editTaskBoardSettingsOnClick(item)
        }
      }
    }, [_c('Icon', {
      staticClass: "board-edit-icon",
      attrs: {
        "type": "android-settings"
      }
    })], 1)])]), _vm._v(" "), _c('task-board', {
      attrs: {
        "board": item.val
      }
    })], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4ec8d2c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskBoards.vue
// module id = 409
// module chunks = 0